'use strict';

class InvalidGlazingTypeError extends Error {}

export { InvalidGlazingTypeError };



// WEBPACK FOOTER //
// ./src/objects/InvalidGlazingTypeError.js